// extracted by mini-css-extract-plugin
export default {"clickRankBox":"index_clickRankBox_L3cfK","clickRankItem":"index_clickRankItem_ANMzf","clickRankNum":"index_clickRankNum_vQO3t","clickRankTitle":"index_clickRankTitle_Jk0o1"};